import { HttpStatusCode } from "axios";
import { AxiosClient } from "../../utils/AxiosClient";
import { baseUrl } from "../apiUrl";

export const PREF_REPORTS = 'homesites-report';
export const PREF_BUYERS = 'buyer-detail';
export const PREF_HOMESITE = 'homesite-detail';
export const PREF_TASKS = 'tasks-detail';

export interface IPrefs {
  id: string;
  groupid: string;
  type: string;
  preference: {[x: string]: IPref};
}

export interface IPref {
  preferences: IColumn[];
  pinned?: { left?: string[]; right?: string[] }; // persist pinned state for custom views
}

export interface IColumn {
  columnName?: string;
  changeVisibilityFlag?: boolean;
  visibilityFlag?: boolean;
}

export const createPrefColumn = (columnName: string | undefined, changeVisibilityFlag: boolean | undefined, visibilityFlag: boolean | undefined): IColumn => {
  return {
    columnName,
    changeVisibilityFlag,
    visibilityFlag
  }
}

export interface IColumnVisibilityModel {
  [key: string]: boolean;
}

export interface IVisibilityFlagCheck {
  [key: string]: boolean;
}

export const getPreferences = async (id: string, page: string) => {  
  const service = baseUrl + `/clo/concierges/${id}/preferences/${page}`;
  const response = await AxiosClient.get<IPrefs>(service);
  return response.data.preference ?? {};
}

export const setPreferences = async (id: string, page: string, updatedPreferences: {[x: string]: IPref}) => {
  const service = baseUrl + `/clo/concierges/${id}/preferences/${page}`;
  const payload = {
    type: "preference",
    id: page,
    groupid: id,
    preference:
      updatedPreferences /* Send updated preferences without the deleted view */,
  };

  const response = await AxiosClient.put<IPrefs>(service, payload);
  
  return response.status === HttpStatusCode.Ok;
}